import { render } from "./html-chapter-1.vue?vue&type=template&id=2da3e8c4"
import script from "./html-chapter-1.vue?vue&type=script&lang=js"
export * from "./html-chapter-1.vue?vue&type=script&lang=js"

import "./html-chapter-1.vue?vue&type=style&index=0&id=2da3e8c4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__